import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';

function CredentialComponent (props) {
    const highlights = props.highlights;

    return(
        <div className='single-credential shadow rounded'>
            <div className='credential-head'>
                <div className='credential-icon'>
                    <FontAwesomeIcon icon={props.icon} style={{color: props.iconColor, fontSize: "34px"}}/>
                </div>
                <div className='credential-heading'>
                    <h3>{props.title}</h3>
                    <span className='credential-issuer'>{props.issuer}</span>
                    <span className='credential-meta'>{props.meta}</span>
                </div>
            </div>
            <p className='credential-description'>{props.description}</p>
            {highlights ?
                <ul className='credential-highlights'>
                    {highlights.map((highlight, index) => {
                        return <li key={index}>{highlight}</li>
                    })}
                </ul>
            : ""}
            {props.credentialId ?
                <p className='credential-id'>Credential ID: {props.credentialId}</p>
            : ""}
            {props.hrefCredential ?
                <a className='credential-link' rel="noreferrer" target='_blank' href={props.hrefCredential}>
                    Show credential <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                </a>
            : ""}
        </div>
    );
}

export default CredentialComponent;
